<template>
	<section class="form-group FormColor" :data-entry="id || name">
		<label v-if="label" class="title" :for="id || name" :class="{ required }">{{ label }}</label>
		<div class="input-area">
			<input class="input" type="text" :id="`${formId}_${id || name}`" v-bind="$attrs" :value="color" @input="onInput($event)" />
			<A :style="{ '--clr': color }" @click="showColorPicker"></A>
		</div>
	</section>
</template>
<script>
	import mixin from './mixin';
	import { showPopup, closePopup } from '../popup/popup';
	import ColorPicker from '../../components/ColorPicker';
	export default {
		mixins: [mixin],
		components: {
			ColorPicker
		},
		data() {
			return {
				color: ''
			};
		},
		methods: {
			onInput(e) {
				this.color = e.target.value;
				this.$emit('change', e.target.value);
			},
			showColorPicker() {
				showPopup('colorpicker', ColorPicker, { height: '60rem', width: '100rem', onColorPick: this.onColorPick });
			},
			onColorPick(color) {
				closePopup('colorpicker');
				this.color = color;
				this.$emit('change', color);
			}
		},
		mounted() {
			this.color = this.value;
		}
	};
</script>
<style scoped lang="scss">
	.FormColor {
		.input-area {
			position: relative;

			input {
				outline: none;
				border: none;
				padding: 1rem 1.5rem;
				background-color: var(--backgroundColor);
				border-radius: 0.5rem;
				font-size: inherit;
			}

			.A {
				display: block;
				width: 3.2rem !important;
				height: 3.2rem;
				border-radius: 4.4rem;
				border: 1px solid rgba(0, 0, 0, 0.1);
				background-color: var(--clr);
				position: absolute;
				right: 0.6rem;
				top: 0.6rem;
				left: initial;

				&:hover {
					filter: brightness(1.2);
				}
			}
		}
	}
</style>
